/**
 * Displays the appointment link.
 * @param {object} props
 * @param {object} props.themeColors Colors for the user's theme.
 * @param {React.ReactNode} props.children The content for the card.
 */
function BookedAppointmentCard({ themeColors, children }) {
    return (
        <div className="body-text rounded-lg text-white" style={{ background: themeColors.secondaryColor }}>
            {children}
        </div>
    );
}

export default BookedAppointmentCard;
